const nonAddressTypes = [
  "route",
  "country",
  "locality",
  "sublocality",
  "political",
  "neighborhood",
];
export const isValidAddress = (
  Address1,
  City,
  State,
  Country,
  Zip,
  AddressTypes
) => {
  const addressTypes = (
    Array.isArray(AddressTypes) ? AddressTypes : [AddressTypes]
  ).filter(Boolean);
  const addressTypeIsForAddress =
    addressTypes.length &&
    !addressTypes.some((a) => nonAddressTypes.includes(a));
  return !!(
    addressTypeIsForAddress &&
    Address1 &&
    City &&
    State &&
    Country &&
    Zip
  );
};
